module.exports = __webpack_public_path__ + "img/icon-fuwubao.987e058b.png";